















































































import { Component, Vue } from 'vue-property-decorator';

import DraggableWidget from '@/components/util/DraggableWidget.vue';
import WorkOrderListView from '@/components/orders/WorkOrderListView.vue';

import { User } from 'oidc-client';
import {
  Workorder,
  QueryWorkOrdersRequest,
  WorkorderPagedCollectionApiResponse,
  PerformoSettings
} from 'performo-api';
import { mapGetters } from 'vuex';
import { SortChangedEvent } from '@/models/SortChangedEvent';

@Component({
  components: {
    DraggableWidget,
    WorkOrderListView
  },
  computed: mapGetters({
    currentPropertyId: 'currentPropertyId',
    currentUser: 'currentUser',
    settings: 'settings'
  })
})
export default class WorkOrderListWidget extends Vue {
  private currentPropertyId!: string;
  private currentUser!: User;
  private settings!: PerformoSettings;

  private pageSize = 5;
  private mineTeamAll!: number; // 3 = all; 1 = mine; 2 = team; only applies within this component
  private statusQuery!: string;
  private sortColumn!: string;
  private sortDirection!: string;
  private pageNumber = 1;
  private pagedOrders!: WorkorderPagedCollectionApiResponse;

  data() {
    return {
      mineTeamAll: undefined,
      statusQuery: undefined,
      sortColumn: undefined,
      sortDirection: undefined,
      pageNumber: 1,
      pagedOrders: undefined
    };
  }

  private doWorkOrderListWidget() {
    // blank
  }

  get currentStatusQuery() {
    return this.statusQuery;
  }

  private sortChangedHandler(sort: SortChangedEvent) {
    this.sortColumn = sort.column;
    this.sortDirection = sort.direction === 1 ? 'ascend' : 'descend';
    // should this be persisted across views?
    // window.localStorage.setItem('homeOrderSortColumn', this.sortColumn);
    // window.localStorage.setItem('homeOrderSortDirection', this.sortDirection);
  }

  private async paginationChangeHandler(pageNumber: number) {
    this.pageNumber = pageNumber;
  }

  private ordersUpdatedHandler(
    pagedOrders: WorkorderPagedCollectionApiResponse
  ) {
    this.pagedOrders = pagedOrders;
  }

  get currentQuery(): QueryWorkOrdersRequest {
    const query: QueryWorkOrdersRequest = {
      propertyId: this.currentPropertyId,
      skip: this.pageSize * (this.pageNumber - 1) + 1
    };

    if (this.sortColumn) {
      query.sortColumn = this.sortColumn;
    }
    if (this.sortDirection) {
      query.sortDirection = this.sortDirection;
    }

    if (this.currentStatusQuery) {
      query.orderStatus = this.currentStatusQuery;
      window.localStorage.setItem(
        'homeStatusQuery',
        query.orderStatus.toString()
      );
      if (query.orderStatus === 'All') {
        query.orderStatus = undefined;
      }
      if (
        query.orderStatus === 'Open' &&
        this.settings.openSubStatuses &&
        this.settings.openSubStatuses.length
      ) {
        query.includeSubStatuses = true;
      }
      if (
        query.orderStatus === 'Complete' &&
        this.settings.completeSubStatuses &&
        this.settings.completeSubStatuses.length
      ) {
        query.includeSubStatuses = true;
      }
    }

    if (this.mineTeamAll == 1) {
      query.assignTo = this.currentUser.profile.WorkerVendor;
    } else if (this.mineTeamAll == 2) {
      query.tradeTeam = this.currentUser.profile.TradeTeam;
    }

    if (this.mineTeamAll) {
      window.localStorage.setItem(
        'homeMineTeamAll',
        this.mineTeamAll.toString()
      );
    }

    return query;
  }

  created() {
    // need to load these in before the component is mounted
    this.statusQuery = window.localStorage.getItem('homeStatusQuery') ?? 'Open';
    this.sortColumn = 'startDateTime';
    this.sortDirection = 'descend';
    const mta = window.localStorage.getItem('homeMineTeamAll');
    if (mta) {
      this.mineTeamAll = parseInt(mta);
    } else {
      this.mineTeamAll = 1;
    }
  }

  private orderClickedHandler(order: Workorder) {
    if (order.workorderId) {
      this.$router.push({
        name: 'work-order-detail',
        params: { id: order.workorderId }
      });
    }
  }
}
